export default __webpack_public_path__ + "static/media/flag-fr-CA.85ced4ce.png";